import I18N from '@leverege/i18n';
import { Tracker } from '@leverege/molten/tracking';
import { DateTime } from 'luxon';
import TimelineUtil from "../TimelineUtil.js";
const id = 'rsrc.dataViewers.actions.JumpToNow';
const {
  t,
  tIcon
} = I18N.ns(id);
export default {
  id,
  name: t('name'),
  matches: {
    client: 'TimelineScrubber',
    use: 'playBar'
  },
  layout: {
    sort: 'zz'
  },
  handles: () => true,
  appearance: ({
    context
  }) => {
    const {
      isPlaying,
      scrubTime
    } = context;
    const scrubDateTime = TimelineUtil.coerceDateTime(scrubTime);
    const now = DateTime.now();
    let visible = true;
    if (now.minus({
      minutes: 1
    }) <= scrubDateTime) {
      visible = false;
    }
    return {
      name: t('name'),
      icon: isPlaying ? tIcon('iconJumpToNow', 'fa-kit fa-fw fa-solid-forward-fast-slash') : tIcon('iconJumpToNow', 'fa fa-fw fa-forward-fast'),
      disabled: isPlaying,
      variant: 'jumpToNow',
      visible
    };
  },
  perform: ({
    context
  }) => {
    const {
      onJumpToNow
    } = context;
    onJumpToNow();
    Tracker.event('Jump To Now Clicked', {
      page_url: window.location.href,
      module: 'Timeline'
    });
  }
};